import { NodoDto, ProprietaMisurataDto } from "@/api";
import Box from "@/elements/Box";
import Button from "@/elements/Button";
import Typography from "@/elements/Typography";
import { Card, Grid } from "@mui/material";

function ProprietaResistenzeMisurateCard({
  dispositivo,
  proprietaMisurate,
  openHistoryDialog,
}: {
  dispositivo: NodoDto;
  proprietaMisurate: ProprietaMisurataDto[];
  openHistoryDialog: () => void;
}) {
  return (
    <Card sx={{ width: 332, height: 304 }}>
      <Box
        p={2}
        display="flex"
        flexDirection="column"
        alignItems="center"
        flex={1}
        height="100%"
      >
        <Typography variant="body2" fontWeight="medium" color="text">
          Resistenze
        </Typography>

        <Box
          display="flex"
          alignItems="center"
          mb={1}
          flexDirection="column"
          justifyContent="center"
          height="100%"
          width="100%"
        >
          <Grid container rowSpacing={1.5} columnSpacing={2}>
            {proprietaMisurate.map((proprietaMisurata) => {
              const value = Number(proprietaMisurata.lastValue?.value);
              const on = value === 1;

              return (
                <Grid item xs={6} key={proprietaMisurata.id}>
                  <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    gap={1}
                  >
                    <Box
                      sx={{
                        width: 14,
                        height: 14,
                        borderRadius: "50%",
                        backgroundColor: on ? "#D32F2F" : "#E0E0E0",
                        boxShadow: on
                          ? "0 0 8px rgba(211, 47, 47, 0.8)"
                          : "none",
                      }}
                    />
                    <Typography variant="button" color="text" fontWeight="regular">
                      {proprietaMisurata.type.labelShort || proprietaMisurata.type.label}
                    </Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>

        <Box width="100%" display="flex" flexDirection="row" mt="auto">
          <Button
            variant="textArrow"
            color="text"
            sx={{ ml: "auto", mr: 0, mt: 1, mb: -1 }}
            onClick={openHistoryDialog}
          >
            Vedi storico
          </Button>
        </Box>
      </Box>
    </Card>
  );
}

export default ProprietaResistenzeMisurateCard;
